import './index.css'

import { Header } from "./elements/Header"
import { Footer } from './elements/Footer'
import { PageContainer } from './elements/PageContainer'

function App() {
    return (
        <div>
            <Header />
            <PageContainer />
            <Footer />
        </div>
    )
}

export default App
